
// Scroll (Management)

export const ScrollService = {
    lenis: null,
    rafId: null,
    options: {
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        direction: 'vertical',
        gestureDirection: 'vertical',
        smooth: true,
        mouseMultiplier: 1,
        smoothTouch: false,
        touchMultiplier: 2,
        infinite: false
    },
    startRaf() {
        const raf = (time) => {
            this.lenis?.raf(time);
            this.rafId = requestAnimationFrame(raf);
        };
        this.rafId = requestAnimationFrame(raf);
    },
    async smooth(apply = true, customOptions = {}) {
        if (this.lenis) return;
        // Studio Freight rebranded to Darkroom Engineering; the npm package is now just "lenis"
        const { default: Lenis } = await import('lenis');
        this.lenis = new Lenis({ ...options, ...customOptions });
        this.lenis.on('scroll', this.handleScroll);
        this.startRaf();
    },
    stop() {
        if (this.rafId) {
            cancelAnimationFrame(this.rafId);
            this.rafId = null;
        }

        if (this.lenis) {
            this.lenis.destroy();
            this.lenis = null;
        }
    }
}
